import React from "react";

import {
  FormControl,
  InputLabel,
  Select as MaterialSelect,
} from "@mui/material";

// import { withStyles } from '@mui/styles';

// import style from './selectStyle';

import { computed } from "mobx";
import { utils } from "@intrasync/utils";
import { injectPropsChildren } from 'shared/common/react';
import injectStores from "../RootStore/injectStores";

interface SelectProps {
  onChange?: (newValue: string | string[]) => void;
  multiple?: boolean;
  label: string;
  value: string | string[];
  children: React.ReactNode;
  fullWidth?: boolean;
  white?: boolean;
  disabled?: boolean;
  size?: "medium" | "small";
  // classes: any;
}

class Select extends React.PureComponent<SelectProps> {
  static defaultProps = {
    fullWidth: true,
    multiple: false,
    white: false,
    disabled: false,
    size: "medium",
    onChange: null, //Added a default onChange prop
  };

  handleChange = (newValue: string | string[]) => {
    const { onChange, multiple } = this.props;
    if (!newValue || newValue === "None") {
      return onChange ? onChange("") : null;
    }
    if (multiple && Array.isArray(newValue)) {
      return onChange ? onChange(newValue.slice().sort()) : null;
    }
    return onChange ? onChange(newValue) : null;
  };
  render() {
    const {
      // classes,
      label,
      value,
      children,
      fullWidth,
      multiple,
      // white,
      disabled,
      size,
    } = this.props;
    const selectId = utils.uuid();

    const childrenWithProps = injectPropsChildren(children, {
      currentValue: value,
    });
    const renderValue = computed(() => {
      if (!multiple || !Array.isArray(value)) return value;
      return value.join(", ");
    }).get();

    const selectValue = computed(() => {
      if (multiple && !Array.isArray(value)) return [value];
      return value;
    }).get();
    return (
      <FormControl
        key={`${selectId}-control`}
        fullWidth={fullWidth}
        // className={`${classes.selectFormControl} ${white ? classes.white : ''}`}
        variant={size === "small" ? "outlined" : "standard"}
        disabled={disabled}
        size={size}
      >
        <InputLabel
          id={`${selectId}-label`}
          // className={`${classes.selectLabel} ${
          //   white && size !== 'small' ? classes.whiteLabel : ''
          // } ${size === 'small' ? classes.smallLabelPadding : ''}`}
        >
          {label}
        </InputLabel>
        <MaterialSelect
          renderValue={() => renderValue || "None"}
          labelId={`${selectId}-label`}
          // MenuProps={{
          //   className: classes.selectMenu,
          // }}
          // classes={{
          //   select:
          //     size === 'small' ? classes.selectSmall : classes.selectMedium,
          // }}
          multiple={multiple}
          value={selectValue}
          onChange={(e) => this.handleChange(e?.target?.value || "")}
        >
          {childrenWithProps}
        </MaterialSelect>
      </FormControl>
    );
  }
}

export default injectStores(Select);
